var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fix-padding", attrs: { fluid: "" } },
    [
      _vm.inquiry
        ? _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-breadcrumbs", {
                    staticClass: "p-0",
                    attrs: { items: _vm.breadcrumbs },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c(
            "v-col",
            { attrs: { lg: "8", xs: "12" } },
            [
              _vm.inquiry
                ? _c(
                    "v-card",
                    {
                      staticClass: "pt-2 px-4 pb-0 mb-4",
                      attrs: { outlined: "", tile: "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              !_vm.inquiry.isEditing
                                ? [
                                    _c("InquiryView", {
                                      attrs: { inquiry: _vm.inquiry },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "action",
                                            fn: function () {
                                              return [
                                                _c("UserInquiryDialog", {
                                                  attrs: {
                                                    inquiry: _vm.inquiry,
                                                  },
                                                  on: {
                                                    inquirySubmited:
                                                      _vm.getInquiry,
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      icon: "",
                                                      color: "red",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return function () {
                                                          _vm.deleteInquiry(
                                                            _vm.inquiry.id
                                                          )
                                                        }.apply(null, arguments)
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      { attrs: { dark: "" } },
                                                      [_vm._v("mdi-delete")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        481334637
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("v-divider"),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-text",
                                      [
                                        _c("div", {
                                          staticClass: "mb-4 html-body",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.inquiry.content
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "d-flex" },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "p-0",
                                                attrs: { cols: "12" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "float-right d-flex",
                                                  },
                                                  [
                                                    _c("v-col", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "grey--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.inquiry.updatedAt.substring(
                                                                0,
                                                                10
                                                              )
                                                            ) +
                                                              "に問い合わせしました"
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-divider"),
                                        _vm._v(" "),
                                        _c("h2", { staticClass: "pt-4" }, [
                                          _vm._v("コメント"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-list",
                                          {
                                            attrs: {
                                              "three-line": "",
                                              dense: "",
                                            },
                                          },
                                          _vm._l(
                                            _vm.inquiry.comments,
                                            function (comment) {
                                              return _c(
                                                "v-list-item",
                                                {
                                                  key: comment.id,
                                                  staticClass: "px-0",
                                                  attrs: {
                                                    id: "comment-" + comment.id,
                                                  },
                                                },
                                                [
                                                  comment.user &&
                                                  comment.user.image
                                                    ? _c("v-list-item-avatar", [
                                                        _c("img", {
                                                          attrs: {
                                                            src: comment.user
                                                              .image.url,
                                                          },
                                                        }),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list-item-content",
                                                    { staticClass: "d-block" },
                                                    [
                                                      !comment.isEditing
                                                        ? [
                                                            _c("div", {
                                                              staticClass:
                                                                "html-body",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    comment.renderedBody
                                                                  ),
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            comment.user &&
                                                            comment.user.id ==
                                                              _vm.user.id
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "d-flex",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-col",
                                                                      {
                                                                        attrs: {
                                                                          cols: "12",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "me-2",
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  comment.isEditing = true
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "編集"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.deleteComment(
                                                                                    comment.id
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "消去"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        : [
                                                            _c("Simplemde", {
                                                              attrs: {
                                                                rows: 3,
                                                                name: "comment-body-new",
                                                              },
                                                              model: {
                                                                value:
                                                                  comment.body,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      comment,
                                                                      "body",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "comment.body",
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-block",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    staticClass:
                                                                      "me-2",
                                                                    attrs: {
                                                                      color:
                                                                        "primary",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.updateComment(
                                                                            comment
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "コメントを送信する"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          comment.isEditing = false
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "キャンセル"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                        _vm._v(" "),
                                        !_vm.inquiry.showCommentForm
                                          ? _c(
                                              "div",
                                              { staticClass: "d-flex" },
                                              [
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "pt-2",
                                                    attrs: { cols: "12" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: "primary",
                                                        },
                                                      },
                                                      [_vm._v("add_comment")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.inquiry.showCommentForm = true
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "コメントを追加…"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              { staticClass: "d-flex" },
                                              [
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c("Simplemde", {
                                                      attrs: {
                                                        rows: 3,
                                                        name: "comment-new",
                                                      },
                                                      model: {
                                                        value: _vm.newComment,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.newComment = $$v
                                                        },
                                                        expression:
                                                          "newComment",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        staticClass: "me-2",
                                                        attrs: {
                                                          color: "primary",
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.createComment,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "コメントを送信する"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.inquiry.showCommentForm = false
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("キャンセル")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ConfirmDialog", { ref: "confirm" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }